<template>
  <div>
    <x-flash></x-flash>

    <!-- <x-menu></x-menu> -->

    <section class="hero">
      <div class="image-wrapper">
        <img class="logo-img" alt="xanadu" src="../assets/xanadu-logo.jpg" />
      </div>
    </section>

    <section class="biography">
      <div class="content" data-fadein>
        <h2>Xanadu</h2>
        <div>
          Xanadu（ザナドゥ）。2019年3月結成。城所志帆理と肥川成希から成るエレクトロディスコファンクデュオ。ジャンルに囚われずボーダレスに様々な音楽に影響を受け、特にエレクトロ、ダンスクラシック、シティポップに強くインスパイアされた楽曲を多く生み出す。
        </div>
      </div>
    </section>

    <section class="music">
      <h2 data-fadein>
        <span class="sub">The First Single</span>"Suger Lounge"
      </h2>
      <div class="screen" data-fadein>
        <iframe
          src="https://www.youtube.com/embed/9AKPf7b1FZU"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </section>

    <section class="members">
      <h2 data-fadein>music by</h2>
      <ul data-fadein>
        <li>
          <a href="https://twitter.com/Shihori_J" target="_blank">
            Shihori Josho
            <!-- 城所志帆理 -->
          </a>
        </li>
        <li>
          <a href="https://twitter.com/Naruki_XANADU" target="_blank">
            Naruki Hikawa
            <!-- 肥川成希 -->
          </a>
        </li>
      </ul>
    </section>

    <section class="news">
      <div class="content">
        <h2 data-fadein>News</h2>
        <ul>
          <li data-fadein>
            <div class="metadata">
              <span class="new">New!</span>
              <span class="tag">RELEASE</span>
              <time datetime="2019-05-29">2019/05/29</time>
            </div>
            <h3>セカンドシングル『Spicy Pasta』の MV が公開</h3>
            <div class="description">
              大塚 Deepa
              <br />OPEN/START 17:00/17:30 <br />出演: お風呂23:28/Xanadu/the
              gliders/感謝のBEバンド/Straycats in the Hollow/REN/the dillows
              [FOOD] <br />料金: ADV/DOOR ¥1,000/¥1,000 +1D￥600
            </div>
          </li>
          <li data-fadein>
            <div class="metadata">
              <span class="tag">LIVE</span>
              <time datetime="2019-05-29">2019/05/29</time>
            </div>
            <h3>セカンドシングル『Spicy Pasta』の MV が公開</h3>
            <div class="description">
              大塚 Deepa OPEN/START 17:00/17:30 出演: お風呂23:28/Xanadu/the
              gliders/感謝のBEバンド/Straycats in the Hollow/REN/the dillows
              [FOOD] 料金: ADV/DOOR ¥1,000/¥1,000 +1D￥600
            </div>
          </li>
        </ul>
      </div>
    </section>

    <section class="schedule">
      <div class="content">
        <h2 data-fadein>Live Schedule</h2>
        <ul>
          <li data-fadein>
            <div class="metadata">
              <span class="new">New!</span>
              <span class="tag">LIVE</span>
              <time datetime="2019-05-29">2019/05/29</time>
            </div>
            <div class="description">
              大塚 Deepa
              <br />OPEN/START 17:00/17:30 <br />出演: お風呂23:28/Xanadu/the
              gliders/感謝のBEバンド/Straycats in the Hollow/REN/the dillows
              [FOOD] <br />料金: ADV/DOOR ¥1,000/¥1,000 +1D￥600
            </div>
          </li>
          <li data-fadein>
            <div class="metadata">
              <span class="tag">LIVE</span>
              <time datetime="2019-05-29">2019/05/29</time>
            </div>
            <div class="description">
              大塚 Deepa OPEN/START 17:00/17:30 出演: お風呂23:28/Xanadu/the
              gliders/感謝のBEバンド/Straycats in the Hollow/REN/the dillows
              [FOOD] 料金: ADV/DOOR ¥1,000/¥1,000 +1D￥600
            </div>
          </li>
        </ul>
      </div>
    </section>

    <footer>
      <ul class="social" data-fadein>
        <li>
          <a href="https://www.instagram.com/xanadu_music/" target="_blank">
            <font-awesome-icon :icon="['fab', 'instagram']" />
          </a>
        </li>
        <li>
          <a href="https://twitter.com/XANADU_disco" target="_blank">
            <font-awesome-icon :icon="['fab', 'twitter']" />
          </a>
        </li>
        <li>
          <a
            href="https://www.youtube.com/channel/UCDYsewiU7u6m_v06uN5b-yQ"
            target="_blank"
          >
            <font-awesome-icon :icon="['fab', 'youtube']" />
          </a>
        </li>
        <li>
          <a href="https://soundcloud.com/user-203339815" target="_blank">
            <font-awesome-icon :icon="['fab', 'soundcloud']" />
          </a>
        </li>
        <li>
          <a href="mailto:xanadumusic54@gmail.com" target="_blank">
            <font-awesome-icon :icon="['fas', 'envelope']" />
          </a>
        </li>
      </ul>
      <div class="copyright" data-fadein>
        © Team Xanadu {{ new Date().getFullYear() }}
      </div>
    </footer>
  </div>
</template>

<script>
import Flash from "../components/Flash";
import Menu from "../components/Menu";

export default {
  name: "Home",
  components: {
    "x-flash": Flash,
    "x-menu": Menu
  },
  mounted() {
    window.addEventListener("scroll", () => {
      const fadeinElements = document.querySelectorAll("[data-fadein]"); // document.getElementsByClassName("fadein");
      for (let i = 0; i < fadeinElements.length; i++) {
        const targetElement = fadeinElements[i].getBoundingClientRect(); // ターゲット要素の高さ
        const scroll =
          document.documentElement.scrollTop || document.body.scrollTop; // スクロール
        const windowHeight = window.innerHeight; // ウィンドウの高さ
        if (scroll > scroll + targetElement.top - windowHeight) {
          fadeinElements[i].style.opacity = "1";
          fadeinElements[i].style.transform = "translateY(0)";
        }
      }
    });
  }
};
</script>

<style lang="scss" scoped>
[data-fadein] {
  opacity: 0;
  transform: translateY(40px);
  transition: 0.6s opacity ease-in-out, 0.6s transform ease-in-out;
}

section {
  h2 {
    font-size: 40px;
    letter-spacing: 0.05em;
  }

  &.hero {
    height: 100vh;

    .image-wrapper {
      height: 100%;
      display: flex;
      align-items: center;
      overflow: hidden;
      position: relative;

      > .logo-img {
        max-width: 100%;
        width: 880px;
        margin: auto;
      }
    }

    > span {
      position: absolute;
      top: 50%;
      right: 0;
      left: 0;
      margin: auto;
    }
  }

  &.biography {
    height: 25vh;
    background-color: #f2f2f2;
    display: flex;
    justify-content: center;
    align-items: center;

    > .content {
      width: 1050px;
      box-shadow: 0 3px 20px rgba(0, 0, 0, 0.02);
      background-color: #fff;
      padding: 80px 120px;

      > h2 {
        margin-bottom: 1em;
      }
    }
  }

  &.music {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #f2f2f2;

    > h2 {
      color: #4464b4;
      margin-bottom: 1em;

      > .sub {
        display: block;
        color: #c2c2c2;
        font-size: 20px;
        text-align: center;
      }
    }

    > .screen {
      box-shadow: 0 12px 24px rgba(0, 0, 0, 1);

      > iframe {
        width: 860px;
        height: 480px;

        @media only screen and (max-width: 768px) {
          width: 80%;
        }
      }
    }
  }

  &.members {
    height: 33vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    > h2 {
      color: #4464b4;
      font-size: 18px;
      margin-bottom: 1em;
    }

    > ul {
      display: flex;
      justify-content: center;
      align-items: center;

      > li {
        padding: 0 40px;
        list-style: none;

        > a {
          position: relative;
          color: #fff;
          text-decoration: none;
          font-size: 32px;

          &::before {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            right: 100%;
            height: 2px;
            background-color: #fff;
            transition: 0.2s all ease-out;
          }

          &:hover {
            &::before {
              right: 0%;
            }
          }
        }
      }
    }
  }

  &.schedule,
  &.news {
    padding: 160px 0;

    > .content {
      width: 860px;
      margin: auto;

      > h2 {
        color: #4464b4;
        margin-bottom: 2em;
        position: relative;

        &::after {
          content: "";
          height: 2px;
          width: 48px;
          position: absolute;
          bottom: -24px;
          left: 0;
          background-color: #c2c2c2;
          margin: auto;
        }
      }

      > ul {
        margin: auto;
        list-style: none;

        > li {
          margin-bottom: 48px;

          > .metadata {
            position: relative;
            margin-bottom: 8px;

            > .new {
              font-family: "Pacifico", cursive;
              font-size: 18px;
              position: absolute;
              top: -20px;
              right: 97.5%;
              line-height: 20px;
              transform: rotate(-20deg);
              color: #d1bc21;

              &::before {
                content: "\\";
                padding-right: 5px;
                font-size: 0.8em;
              }

              &::after {
                content: "/";
                padding-left: 5px;
                font-size: 0.8em;
              }
            }

            > .tag {
              background-color: #182036;
              color: #fff;
              padding: 0 8px;
              margin-right: 8px;
            }
          }

          > h3 {
            font-size: 22px;
            line-height: 1.5em;
            margin-bottom: 8px;
          }

          > .description {
            line-height: 1.6;
          }
        }
      }
    }
  }

  &.news {
    background-color: #f2f2f2;
  }

  &.schedule {
    color: #fff;

    .tag {
      background-color: #e4e4e4 !important;
      color: #182036 !important;
    }

    .description {
      color: #e4e4e4;
    }
  }
}

footer {
  width: 1050px;
  margin: auto;
  padding: 80px 0 120px;
  color: #323232;
  text-align: center;

  > ul.social {
    list-style: none;
    display: flex;
    justify-content: center;

    > li {
      margin: 0 8px;

      > a {
        font-size: 24px;
        color: #323232;

        &:hover {
          color: #c2c2c2;
        }
      }
    }
  }

  > .copyright {
    font-size: 12px;
    margin-top: 1em;
  }
}
</style>
